// extracted by mini-css-extract-plugin
export default {"button":"link-mini__button___78e7q link__button___3l2Cw base__button___zT0JW"};